export default __webpack_public_path__ + "static/media/PPI-patio-022.23ae20c7.jpg";